import { callWrapper } from 'api/utils';
import axios from 'axios';

const path = '/api/pages';

const pages = {
    get: callWrapper((id) => axios.get(`${path}/${id}`)),
    getDynamicPage: callWrapper((id) =>
        axios.get(`${path}/dynamic-app-page/${id}`)
    ),
    getPublicPage: callWrapper((id) => axios.get(`/api/public/page/${id}`)),
    getLandingPage: callWrapper(() => axios.get(`${path}/landing`)),
};
export default pages;
